import { HsShaderType } from '../enums/shader-type.enum';
import { hsCompileShader } from './compile-shader.function';

/**
 * Handles s compile shader program.
 */
export function hsCompileShaderProgram(
  gl: WebGL2RenderingContext,
  vertexCode: string,
  fragmentCode: string,
  deferValidation: boolean = false
): WebGLProgram {
  let vertexShader: WebGLShader | null = null;
  let fragmentShader: WebGLShader | null = null;
  let program: WebGLProgram | null = null;
  try {
    vertexShader = hsCompileShader(gl, vertexCode, HsShaderType.vertexShader, deferValidation);
    fragmentShader = hsCompileShader(gl, fragmentCode, HsShaderType.fragmentShader, deferValidation);
    program = gl.createProgram();
    if (program === null) {
      throw new Error(`ERROR: compileShaderProgram - Failed to create WebGLProgram`);
    }
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!deferValidation && !Boolean(gl.getProgramParameter(program, gl.LINK_STATUS))) {
      throw new Error(`ERROR: compileShaderProgram - Program link error: ${gl.getProgramInfoLog(program)}`);
    }
    return program;
  } catch (error: unknown) {
    gl.deleteProgram(program);
    throw error;
  } finally {
    gl.deleteShader(vertexShader);
    gl.deleteShader(fragmentShader);
  }
}
